import {createSlice} from '@reduxjs/toolkit'

const initialState  = {
    password:undefined,
    link:undefined,
    examType: undefined,
    completedForms: [],
    formList: [],
    triageScore: 0,
}

const examSlice = createSlice({
    name:'exam',
    initialState,
    reducers:{
        setExamPassword(state,action){
            state.password = action.payload;
        },
        setExamLink(state,action){
            state.link = action.payload;
        },
        setExamType(state,action){
            state.examType = action.payload;
        },
        setCompletedForms(state,action){
            state.completedForms = action.payload;
        },
        setFormList(state,action){
            state.formList = action.payload;
        },
        setTriageScore(state,action){
            state.triageScore = action.payload;
        },
        resetState(state){
            state = initialState;
        }
    }
});

export const {setExamPassword,setExamLink,setExamType,setCompletedForms,setFormList,setTriageScore,resetState} = examSlice.actions;
export default examSlice.reducer;